import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { NodeType } from 'src/app/asistente-en-linea/components/asistencia-menu-arbol/models/node-type';
import { NodoArbolMenu } from 'src/app/asistente-en-linea/components/asistencia-menu-arbol/models/nodo-arbol-menu';
import { DestinatarioMenu } from '../../../asistente-en-linea/models/DestinatarioMenu';
import { Destinatario } from '../../../asistente-en-linea/models/Destinatario';
import { AuthService } from '../../auth/auth.service';
import { EditingMode } from '../../models/editingMode';
import { ConfigService } from '../config.service';
import { MenuService } from '../../config/menu/menu.service';
import { DestinatarioTipo } from '../models/destinatario-tipo';
import { Nodo } from 'src/app/asistente-en-linea/models/Nodo';
import { ValidacionesService } from '../validaciones/validaciones.service';
import { Validacion } from '../../../asistente-en-linea/models/Validacion';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute } from '@angular/router';



@Component({
  selector: 'app-editing',
  templateUrl: './editing.component.html',
  styleUrls: ['./editing.component.scss']
})
export class EditingComponent implements OnInit, OnChanges {

  @Output("reloadConfig") reloadConfig: EventEmitter<string>;
  @Output("nodeEmitter") nodeEmitter: EventEmitter<string>;
  @Input("parentId") parentId: string;
  @Input("parent") parent: NodoArbolMenu;
  
  @Input("idMenu") idMenu: string;

  @Input("siblingsArr") siblingsArr: NodoArbolMenu[];
  @Input("siblingsArrTmp") siblingsArrTmp: NodoArbolMenu[];

  @Input("cantidadNodos") cantidadNodos: number;

  @Input("numberOfSiblingsArr") numberOfSiblingsArr: number[];
  @Input("numberOfSiblingsArrCreation") numberOfSiblingsArrCreation: number[];

  @Input() editingMode: EditingMode;
  @Input() faqsGlobal: any[] = [];




  node: NodoArbolMenu;
  destinatariosMenu: DestinatarioMenu[];
  destinatariosMenuDisponibles: DestinatarioMenu[]; // Se filtran los destinatarios según el tipo de nodo
  destinatarioSeleccionado: DestinatarioMenu;
  tipoFormularioSeleccionado: string;
  editingDataSubscription: Subscription
  name: string;
  url: string;
  answer: string = '';
  answerOld: string;
  assistanceId: string;
  codigoAsistenteAccion: string;
  areaName: string; //Nombre del TemaDestinatario
  position: number; //orden
  esFormulario: boolean;
  nodeTypes: string[];
  nodeType: string;
  loading: boolean;
  possibleFaqs: any;
  typeFaq: boolean;
  temaMotivo: string = '';
  selectedFAQNodes: Map<string, NodoArbolMenu>;
  codigoTemaDestinatarioMap: Map<string, string>;
  codigoTemaDestinatarioReverseMap: Map<string, string>;
  temaDestinatarioList: string[];
  tipoFormulario: string = '';
  tipoVinculacion: string = '';
  requiereAutenticacion: boolean;
  visible: boolean = true;
  contenidoInnova: boolean = false;
  idContenido: string = '';
  encoladoMaximo: number;
  guardarHistorico = true;
  listaValidaciones: number[] = [];
  validaciones: Validacion[];
  validacionesMenuSeleccionados: Number[];
  displayedColumns = ['select', 'nombre', 'tipo', 'habilitado'];
  dataSource: any;
  selection: any;
  initialSelection: any;
  allowMultiSelect: boolean;
  sinDestinatarios: boolean = false;
  referenciadoEnFAQ: boolean = false;
  requiereEncuesta = false;
  codigoEncuesta: string = '';

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  optionsTipoFormulario = [
    { label: 'Persona', value: '0' },
    { label: 'Empresa', value: '1' },
  ]

  optionsTipoVinculacion = [
    { label: '--Ninguno--', value: '' },
    { label: 'Destinatario', value: '0' },
    { label: 'Asistente', value: '1' },
  ]

  maxPathLength: number = 200;
  /**
    numberOfSiblingsArr: number[];
    numberOfSiblingsArrCreation: number[];
  **/
  errorValidacionCreacionNodo: boolean = false;
  codigoAsistente: string;
  urlNodo: string;
  mostrarURL: boolean = false;
  /**
   *  Constructor
   * @param configService
   * @param authService
   */
  constructor(private validacionesService: ValidacionesService,private route: ActivatedRoute, private configService: ConfigService, private authService: AuthService, private menuService: MenuService) {
    this.referenciadoEnFAQ= false;
    this.errorValidacionCreacionNodo = false;
    this.editingMode = EditingMode.Off;
    this.loading = false;
    this.typeFaq = false;
    this.initialSelection = [];
    this.allowMultiSelect = true;
    this.selection = new SelectionModel<Validacion>(this.allowMultiSelect, this.initialSelection);
    this.selectedFAQNodes = new Map<string, NodoArbolMenu>()
    this.reloadConfig = new EventEmitter<string>();
    this.nodeEmitter = new EventEmitter<string>();
    this.nodeTypes = Object.keys(NodeType).map(key => NodeType[key]).filter(value => (typeof value === 'string') && (value !== "FAQ")) as string[];
    this.nodeType = "PREGUNTA";
    this.codigoTemaDestinatarioMap = new Map<string, string>()
      .set("Declaración de trabajadores", "1")
      .set("Declaración de nóminas", "2")
      .set("Facturación y pagos", "3")
      .set("Información de gestiones para empresas", "4")

      .set("MOE Créditos", "5") //ConsultasCreditosRNOM@bps.gub.uy
      .set("MOE Asistencia al Contribuyente", "6") //AsistalContri@bps.gub.uy
      .set("MOE Gestión de Cobro Vía Administrativa", "7") //GCVAConsultas@bps.gub.uy
      .set("MOE Nóminas", "8") //ConsultasRNOM@bps.gub.uy


      ;
    this.codigoTemaDestinatarioReverseMap = new Map<string, string>()
      /** .set( "1","Declaración de trabajadores")
       .set("2","Declaración de nóminas")
       .set("3","Facturación y pagos")
       .set("4","Información de gestiones para empresas")
       .set("5","MOE Créditos")
       .set("6","MOE Asistencia al Contribuyente")
       .set("7","MOE Gestión de Cobro Vía Administrativa")
       .set("8","MOE Nóminas")**/
      ;

    this.temaDestinatarioList = Array.from(this.codigoTemaDestinatarioMap.keys());
    this.obtenerDestinatariosPosibles();
    this.loadValidaciones();
  }

  /**
   * Deteccion de modificaciones
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    console.log("---------Editing.component ngOnChange ----------------");
    if(this.typeFaq) {
      this.loadPossibleFaq();
    }
    
  }

  /**
   * Inicializacion del componente
   */
  ngOnInit() {
    this.errorValidacionCreacionNodo = false;
    this.route
      .queryParamMap
      .subscribe((params: any) => {
        this.idMenu = params.params.idMenu;
        this.codigoAsistente = params.params.codigoAsistente;
      })
    this.loadDestinatariosMenu();
  }

  onSelected(selectedValue) {
    this.tipoFormulario = selectedValue;
  }

  onTipoVinculacionChange(tipo: string) {
    this.tipoVinculacion = tipo;

    switch (tipo) {
      case '1': // Asistente
        this.destinatarioSeleccionado = null;
        this.tipoFormulario = null;
        this.temaMotivo = null;
        break;

      case '0': // Destinatario
        this.codigoAsistenteAccion = null;
        break;

      default: // Ninguno
        this.codigoAsistenteAccion = null;
        this.destinatarioSeleccionado = null;
        this.tipoFormulario = null;
        this.temaMotivo = null;
        break;
    }
  }


  resetComponent() {
    this.typeFaq = false;
    this.name = '';
    this.answer = '';
    this.idContenido = null;
    this.url = '';
    this.tipoVinculacion = '';
    this.position = null;
    this.assistanceId = null;
    this.codigoAsistenteAccion = null;
    this.requiereAutenticacion = false;
    this.visible = true;
    this.guardarHistorico = false;
    this.requiereEncuesta = false;
    this.codigoEncuesta=null;
    this.encoladoMaximo = null;
    this.listaValidaciones = [];
    this.selection.clear();

    this.node = undefined;

    this.destinatarioSeleccionado = null;
    this.temaMotivo = null;
    this.tipoFormulario = null;

    this.nodeType = null;
    this.parentId = null;
    this.siblingsArrTmp = [];

    this.editingMode = EditingMode.Off;
  }


  //Para utilizar el enum en el template
  public get EditingMode() {
    return EditingMode;
  }
  public get NodeType() {
    return NodeType;
  }

  textChanged($event) {
    if ($event == null || $event.html == null) {
      return;
    }
    let tamanio = $event.html.length;
    if (tamanio > 2000) {
      // $event.editor.deleteText(2000, tamanio);
      let oldDelta = $event['oldDelta'];
      if (oldDelta == null || (oldDelta && oldDelta.ops && oldDelta.ops.length <= 1)) {
        return;
      }
      $event.editor.setContents(oldDelta.ops);
      //this.answerOld = $event.html;
    } else {
      this.answerOld = $event.html;
    }
    this.answer = this.answerOld;
  }

  cancelOperation() {
    this.selectedFAQNodes = new Map<string, NodoArbolMenu>();
    this.node = undefined;
    this.typeFaq=false;
    this.tipoVinculacion = '';
    this.editingMode = EditingMode.Off;
    // se remueve mensaje de error en la creacion
    this.errorValidacionCreacionNodo = false;
    this.obtenerDestinatariosPosibles();
  }

  async applyOperation() {
    this.listaValidaciones = [];
    this.loading = true;
    this.errorValidacionCreacionNodo = false;
    if (this.isCreateNodeDataValid()) {
      //this.loading = true
      let resArray = [];
      let nodosActualizar = [];
      //let previousPosition = this.node.order;
      let contador = 0;
      if (this.siblingsArrTmp) {
        for (let nodo of this.siblingsArrTmp) {
          contador = contador + 1;
          if (nodo.id == this.node.id) {
            break;
          }
        }
      }
      let previousPosition = contador;
      let newPosition = this.position;
      let codigoTemaDest;
      if (this.nodeType === 'PREGUNTA') {
        this.answer = null;
        this.idContenido = null;
        //this.assistanceId = null;
        //this.codigoAsistenteAccion = null;
      }

      if (this.nodeType === 'ACCION') {
        this.idContenido = null;
        this.url = null;
        this.answer = null;
      }

      if (this.nodeType === 'TRAMITE') {
        this.answer = null;
        this.url = null;
        let idDestinatario = null;
        let tipoFormulario = null;
        let temaMotivo = null;
        let codigoAsistenteAccion = null;

        if (this.tipoVinculacion === '1') {
          codigoAsistenteAccion = this.codigoAsistenteAccion;
        }

        if (this.tipoVinculacion === '0') {
          idDestinatario = this.destinatarioSeleccionado?.destinatario?.id ?? null;
          tipoFormulario = this.tipoFormulario;
          temaMotivo = this.temaMotivo;
        }

      }

      if (this.nodeType === 'ENLACE') {
        this.answer = null;
        this.assistanceId = null;
        this.codigoAsistenteAccion = null;
        this.idContenido = null;
      }

      if (this.nodeType === 'RESPUESTA') {
        this.assistanceId = null;
       // this.codigoAsistenteAccion = null;
        this.url = null;
        if (this.contenidoInnova) {
          this.answer = null;
          this.idContenido = this.idContenido || '';
        } else {
          this.idContenido = '';
        }

      }

      let nodoCrearActualizar: Partial<Nodo> = {};
      if (!previousPosition || previousPosition > this.numberOfSiblingsArr.length) {
        previousPosition = this.numberOfSiblingsArr.length;
      }

      let previousIndex = previousPosition - 1;
      let newIndex = newPosition - 1;

      this.selection._selection.forEach((item) => {
        this.listaValidaciones.push(item.id)
      });
      if (previousPosition != undefined) {
        let nodeUpdate = this.siblingsArrTmp[previousIndex];
        if (nodeUpdate) {

          // codigoTemaDest = this.destinatarioSeleccionado && this.destinatarioSeleccionado.destinatario ? this.destinatarioSeleccionado.destinatario.codigo : "";
          nodoCrearActualizar = {
            idNodo: nodeUpdate.id,
            nombre: this.name,
            url: this.url,
            tipoNodo: this.nodeType,
            idPadre: (this.node.parentId != "ROOT") ? this.node.parentId : null,
            respuesta: this.answer,
            idContenido: this.idContenido,
            orden: this.position,
            idAsistente: this.node.idAsistente,
            usuarioActualizacion: this.authService.getUser().username,
            tipoFormulario: this.destinatarioSeleccionado ? this.tipoFormulario : null,
            temaMotivo: this.destinatarioSeleccionado ? this.temaMotivo : null,
            idDestinatario: this.codigoAsistenteAccion ? null : this.destinatarioSeleccionado ? this.destinatarioSeleccionado.destinatario.id : null,
            idAsistenteAccion: this.assistanceId,
            codigoAsistenteAccion: this.codigoAsistenteAccion,
            requiereAutenticacion: this.requiereAutenticacion,
            visible: this.visible,
            encoladoMaximo: this.encoladoMaximo,
            guardarHistorico: this.guardarHistorico,
            requiereEncuesta:this.requiereEncuesta,
            codigoEncuesta:this.codigoEncuesta,
            listaValidaciones: this.listaValidaciones
          } as Partial<Nodo>
        }
        let node;
        let postNode = 0;
        //nodos que se mueven pero no fueron modificados directamente
        for (let i = 1; i <= this.siblingsArrTmp.length; i++) {
          node = this.siblingsArrTmp[i - 1];
          if (node) {
            if (node.id != nodeUpdate.id) {
              postNode++;
              if (postNode == this.position) {
                postNode++;
              }

              let nodoUpdate = {
                idNodo: node.id,
                pregunta: node.name,
                url: node.url,
                idContenido: node.idContenido,
                respuesta: node.answer,
                idAsistencia: node.assistanceId,
                codigoAsistenteAccion: this.codigoAsistenteAccion,
                orden: postNode,
                userName: this.authService.getUser().username,
                idAsistente: this.node.idAsistente,
                encoladoMaximo: this.encoladoMaximo,
                guardarHistorico: this.guardarHistorico,
                requiereEncuesta:this.requiereEncuesta,
                codigoEncuesta:this.codigoEncuesta
                // codigoTemaDestinatario: node.areaCode && node.areaCode != '-1' ? node.areaCode : '',
                // esFormulario: node.esFormulario,
                // tipoNodo: node.type
              } as Partial<Nodo>
              nodosActualizar.push(nodoUpdate);
            }
          }
        }
      } else {
        nodoCrearActualizar = {
          idNodo: this.node.id,
          nombre: this.name,
          url: this.url,
          tipoNodo: this.nodeType,
          idPadre: (this.node.parentId != "ROOT") ? this.node.parentId : null,
          respuesta: this.answer,
          orden: this.position,
          idAsistente: this.node.idAsistente,
          usuarioActualizacion: this.authService.getUser().username,
          tipoFormulario: this.tipoFormulario,
          temaMotivo: this.temaMotivo,
          idDestinatario: this.codigoAsistenteAccion ? null : this.destinatarioSeleccionado.destinatario.id,
          idAsistenteAccion: this.assistanceId,
          codigoAsistenteAccion: this.codigoAsistenteAccion,
          requiereAutenticacion: this.requiereAutenticacion,
          visible: this.visible,
          idContenido: this.idContenido,
          encoladoMaximo: this.encoladoMaximo,
          guardarHistorico: this.guardarHistorico,
          requiereEncuesta:this.requiereEncuesta,
          codigoEncuesta:this.codigoEncuesta,
          listaValidaciones: this.listaValidaciones
        } as Partial<Nodo>
      }

      resArray.push(await this.configService.addUpdateNodes(this.node.idAsistente, this.authService.getUser().username, nodoCrearActualizar, nodosActualizar).toPromise().catch((err) => {
        this.loading = false;
        alert(err);
        this.resetComponent()
      }));

      let noErr = resArray.reduce((previous, current) => {
       // debugger
        return previous && (current.statusCode == 200 || current.statusCode == 0);
      }, true)


      if (noErr) {
        this.node.name = this.name;
        this.node.url = this.url;
        this.node.answer = this.answer;
        this.node.idContenido = this.idContenido;
        this.node.assistanceId = this.assistanceId;
        this.node.codigoAsistenteAccion = this.codigoAsistenteAccion,
          this.node.order = this.position;
        this.nodeEmitter.emit(this.node.parentId);
        // this.nodeEmitter.emit(this.node.id);
        this.reloadConfig.emit(this.idMenu);
        this.resetComponent()
        this.loading = false;
      }
      else {
        this.loading = false;
        alert("Ocurrió un error, intente nuevamente más tade");
        this.resetComponent()
      }
      this.errorValidacionCreacionNodo = false;
    } else {
      this.loading = false;
      this.errorValidacionCreacionNodo = true;
    }
  }

  getFormattedDate(date) {
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');

    let hour = date.getHours().toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    let seconds = date.getSeconds().toString().padStart(2, '0');
    return day + '/' + month + '/' + year + " " + hour + ":" + minutes + ":" + seconds;
  }

  async loadValidaciones() {
    this.validaciones = [];

    this.loading = true;

    let resArray = [];
    this.loading = true;
    resArray.push(await this.validacionesService.loadValidaciones(false).toPromise().catch((err) => {
      this.loading = false;
      alert(err);
    }));

    let noErr = resArray.reduce((previous, current) => {
      if (previous && (current.statusCode == 200 || current.statusCode == 0)) {
        const resultado = current.content;
        if (resultado.length > 0) {
          for (let m of resultado) {
            let val = new Validacion(
              m.id,
              m.codigo,
              m.nombre,
              m.tipo,
              "",
              "",
              "",
              m.habilitado
            );
            this.validaciones.push(val);
          }
        }
        return true;
      }
      return false;
    }, true);

    if (noErr) {
      this.dataSource = new MatTableDataSource(this.validaciones);
      this.dataSource.paginator = this.paginator;
    }
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }


  onContenidoInnovaChange() {
    if (this.contenidoInnova) {
      this.idContenido = '';
      this.answer = '';
    } else {
      this.idContenido = '';
      this.answer = '';
    }

    if (this.node) {
      this.node.idContenido = this.idContenido;
      this.node.answer = this.answer;
    }
  }


  async loadDestinatariosMenu() {
    this.loading = true;
    this.siblingsArrTmp = [];
    this.destinatariosMenu = [];
    this.destinatariosMenu.push(new DestinatarioMenu(
      null,
      new Destinatario(null, "", "", "--Ninguno--", "", "", "", "", "", true),
      "",
      "",
      ""
    ));

    let resArray = [];
    resArray.push(await this.menuService.loadDestinatariosMenu(this.idMenu, false).toPromise().catch((err) => {
      this.loading = false;
      alert(err);
    }));
    let resultadoMenus = [];
    let noErr = resArray.reduce((previous, current) => {
      resultadoMenus = current.content;
      return previous && (current.statusCode == 200 || current.statusCode == 0 ? true : false);
    }, true);

    if (noErr) {
      if (resultadoMenus.length > 0) {
        for (let m of resultadoMenus) {
          let destMenu = new DestinatarioMenu(
            m.id,
            m.destinatario ?
              new Destinatario(
                m.destinatario.id,
                m.destinatario.codigo,
                m.destinatario.descripcion,
                m.destinatario.titulo + " (" + (m.destinatario.target) + ")",
                m.destinatario.targetType,
                m.destinatario.target,
                this.getFormattedDate(new Date(m.destinatario.fechaCreacion)),
                this.getFormattedDate(new Date(m.destinatario.fechaActualizacion)),
                m.destinatario.usuarioAutualizador,
                m.destinatario.habilitado
              )
              : null,
            this.getFormattedDate(new Date(m.fechaCreacion)),
            this.getFormattedDate(new Date(m.fechaActualizacion)),
            m.usuarioActualizacion
          );
          this.destinatariosMenu.push(destMenu);
          //this.codigoTemaDestinatarioReverseMap.set(destMenu.destinatario.id.toString(),destMenu.destinatario.titulo) ;
        }
      }
      this.loading = false;
      this.esFormulario = false;
      this.obtenerDestinatariosPosibles();

      this.configService.getEditingDataSubject$().subscribe((editingData: { node: NodoArbolMenu, mode: EditingMode }) => {
        this.errorValidacionCreacionNodo = false;
        this.destinatarioSeleccionado = undefined;
        this.position = undefined;
        this.urlNodo= '';
        this.mostrarURL=false;
        this.esFormulario = editingData.node.esFormulario;
        this.siblingsArrTmp = [];
        if (this.codigoAsistenteAccion) {
          this.tipoVinculacion = '1';
        } else if (editingData.node.idDestinatario) {
          this.tipoVinculacion = '0';
        } else {
          this.tipoVinculacion = '';
        }
        if(this.parent && this.parent.type===NodeType.Tramite) {
          this.nodeType = NodeType.Response;
          this.visible = false;
        } else {
          this.nodeType = editingData.node.type;
        }
        
        this.obtenerDestinatariosPosibles();
        this.selection.clear();

        this.node = editingData.node;

        if (this.faqsGlobal) {
          this.referenciadoEnFAQ = this.faqsGlobal.some(
            (f: any) => f.idNodo === this.node.id
          );
        }

        if (editingData.node.type === NodeType.FAQ && editingData.mode === EditingMode.Create) {
          this.loading = false;
          this.typeFaq = true;
          
          this.editingMode = editingData.mode;
          this.loadPossibleFaq();
          this.loading = false;
        }
        else {
          this.typeFaq = false;
          
          if (editingData.mode === EditingMode.Update) {
            for (let m of editingData.node.listaValidaciones) {
              this.dataSource.data.forEach(row => {
                if (row.id == m) {
                  this.selection.toggle(row);
                  this.selection.isSelected(row)
                  this.selection.select(row);
                  return;
                }
              });
            }

            // precargamos las listas cuando estamos en modo edicion
            this.position = editingData.node.order;
            // temaDestinatarioList se crea como lista ordenada segun el codigoTemaDestinatario
            this.areaName = this.codigoTemaDestinatarioReverseMap.get(editingData.node.areaCode);

            // Asigno el destinatario
            for (let m of this.destinatariosMenu) {
              if (
                (m.destinatario.id == editingData.node.idDestinatario) ||
                (!editingData.node.idDestinatario && m.destinatario.titulo === "--Ninguno--")
              ) {
                this.destinatarioSeleccionado = m;
                break;
              }
            }

            // busco el tipo de formulario
            //             let tipoFormulario = this.optionsTipoFormulario.find(x=> x.value == this.node.tipoFormulario);
            // if(tipoFormulario != null){
            //   this.tipoFormulario = tipoFormulario.value;
            // }
            //asigno atributos
            this.tipoFormulario = this.node.tipoFormulario;
            this.temaMotivo = this.node.temaMotivo;
            this.requiereAutenticacion = this.node.requiereAutenticacion;
            this.visible = this.node.visible;
            this.encoladoMaximo = this.node.encoladoMaximo;
            this.guardarHistorico = this.node.guardarHistorico;
            this.requiereEncuesta = this.node.requiereEncuesta;
            this.codigoEncuesta = this.node.codigoEncuesta;
          }

          //console.log("node", this.node);
          this.editingMode = editingData.mode;
          if (editingData.mode === EditingMode.Update || editingData.mode === EditingMode.Delete) {
            this.name = (' ' + this.node.name).slice(1);
            const rawIdContenido = this.node.idContenido;
            this.contenidoInnova = rawIdContenido !== undefined && rawIdContenido !== null && String(rawIdContenido).trim() !== '';
          } else {
            // Es modo creacion
            this.name = undefined;
          }
          this.assistanceId = (' ' + this.node.assistanceId).slice(1) == "undefined" ? undefined : (' ' + this.node.assistanceId).slice(1);
          this.codigoAsistenteAccion = (' ' + this.node.codigoAsistenteAccion).slice(1) == "undefined" ? undefined : (' ' + this.node.codigoAsistenteAccion).slice(1);
          if (editingData.node.type === NodeType.Tramite || editingData.node.type === NodeType.Question  || editingData.node.type === NodeType.Response) {
            this.tipoVinculacion = '0';
            if (this.codigoAsistenteAccion) {
              this.tipoVinculacion = '1';        // Asistente
            } else if (editingData.node.idDestinatario) {
              this.tipoVinculacion = '0';        // Destinatario
            } 
          }


          this.answer = (' ' + this.node.answer).slice(1) == "undefined" ? undefined : (' ' + this.node.answer).slice(1);
          this.idContenido = (' ' + this.node.idContenido).slice(1) == "undefined" ? undefined : (' ' + this.node.idContenido).slice(1);
          this.url = (' ' + this.node.url).slice(1) == "undefined" ? undefined : (' ' + this.node.url).slice(1);


          this.answerOld = this.answer;
          let tamanio = 0;

          if (editingData.mode === EditingMode.Create) {
            this.parentId = this.node.parentId;
            if (this.node.parentId == 'ROOT') {
              this.siblingsArrTmp = this.siblingsArr;
            } else {
              for (let nodo of this.siblingsArr) {
                if ((nodo.id == this.node.parentId && nodo.type === NodeType.Question)) {
                  this.siblingsArrTmp = nodo.childs || [];
                  break;
                } else if ((nodo.parentId == this.node.parentId)) {
                  this.siblingsArrTmp.push(nodo);
                }
              }
            }
          } else {
            this.siblingsArrTmp = this.siblingsArr;
          }
          tamanio = this.siblingsArrTmp.length;

          this.numberOfSiblingsArr = Array.from({ length: tamanio }, (_, i) => i + 1);
          this.numberOfSiblingsArrCreation = Array.from({ length: tamanio + 1 }, (_, i) => i + 1);
          this.loading = false;
        }
      })
    } else {
      this.loading = false;
      alert("Ocurrió un error, intente nuevamente más tade");
    }
  }


  generarURL() {
    this.urlNodo= 'codAsistente=' + this.codigoAsistente + '&idNodo=' + this.node.id;
    this.mostrarURL=true;
  }

  onDestinatarioChange(destinatario: DestinatarioMenu) {
    this.destinatarioSeleccionado = destinatario;

    // Si se selecciona “--Ninguno--”, limpio campos dependientes
    if (!destinatario || destinatario.destinatario.titulo === "--Ninguno--") {
      this.temaMotivo = undefined;
      this.tipoFormulario = undefined;
      this.esFormulario = false;
    } else {
      this.esFormulario = true;
    }
  }

  marcarFaq() {
    if(this.possibleFaqs) {
      this.possibleFaqs.forEach((row) => {
        this.parent.faqs.forEach((faq) => {
          if(faq?.idNodo===row.id) {
            this.selection.toggle(row);
            this.selection.isSelected(row)
            this.selection.select(row);
          }
        });  
      });
    }
  }

  loadPossibleFaq() {
    this.possibleFaqs = [];
    this.loading = true
    this.configService.loadPossibleFAQs(this.idMenu).subscribe((res: any) => {
      if (res.statusCode == 200 || res.statusCode == 0) {
        this.possibleFaqs = res.content;
        this.marcarFaq();
        this.updateVisiblePath();
        this.loading = false;
      }
      else {
        this.loading = false;
        alert(res.statusMessage);
        this.resetComponent()
      }
    },
      error => {
        this.loading = false;
        alert(error);
        this.resetComponent()
      })
    
  }


  async createNode() {
    this.loading = true;
    if (this.editingMode === EditingMode.Create && this.typeFaq == true) {
      let faqNodes = Array.from(this.selectedFAQNodes.values()).map((node) => {
        return { idMenu: this.idMenu, idNodo: node.id, idPadre: this.node.parentId, usuarioModificador: this.authService.getUser().username, esFormulario: false }
      })

      if(faqNodes && faqNodes.length > 0) {
        for await (let faqNode of faqNodes) {
          let res: any = await this.configService.createFaqNode(faqNode.idMenu, faqNode.idNodo, faqNode.idPadre, faqNode.usuarioModificador).toPromise();
          this.loading = false;
          if (res.statusCode == 200 || res.statusCode == 0) {
            this.selectedFAQNodes = new Map<string, NodoArbolMenu>();
            this.reloadConfig.emit(this.idMenu);
            this.resetComponent();
          }
          else {
            alert(res);
          }
        }
      } else {
        this.loading = false;
        this.selectedFAQNodes = new Map<string, NodoArbolMenu>();
        this.reloadConfig.emit(this.idMenu);
        this.resetComponent();
      }
      

    } else {
      if (this.isCreateNodeDataValid()) {
        // Crea nodo del arbol
        //this.node.parentId = this.parentId === "ROOT" ? null : this.node.parentId
        if (this.parentId) {
          this.node.parentId = this.parentId === "ROOT" ? null : this.parentId
        } else {
          this.node.parentId = this.node.parentId === "ROOT" ? null : this.node.parentId
        }

        //debugger
        //console.log(this.node)
        let resArray = [];
        let nodosActualizar = [];
        this.listaValidaciones = [];
        this.selection._selection.forEach((item) => {
          this.listaValidaciones.push(item.id)
        });

        if (this.nodeType === 'PREGUNTA') {
          this.answer = null;
          this.idContenido = null;
          //this.assistanceId = null;
          //this.codigoAsistenteAccion = null;
        }

        if (this.nodeType === 'ACCION') {
          this.idContenido = null;
          this.url = null;
          this.answer = null;
        }

        if (this.nodeType === 'TRAMITE') {
          this.answer = null;
          //this.assistanceId = null;
          this.url = null;
        }

        if (this.nodeType === 'ENLACE') {
          this.answer = null;
          this.assistanceId = null;
          this.codigoAsistenteAccion = null;
          this.idContenido = null;
        }

        if (this.nodeType === 'RESPUESTA') {
          this.assistanceId = null;
          //this.codigoAsistenteAccion = null;
          this.url = null;
        }


        const nodoCrearActualizar: Partial<Nodo> = {
          idNodo: '',
          nombre: this.name,
          tipoNodo: this.nodeType,
          idPadre: this.node.parentId,
          respuesta: this.answer,
          idContenido: this.idContenido,
          url: this.url,
          orden: this.position,
          idAsistente: this.node.idAsistente,
          usuarioActualizacion: this.authService.getUser().username,
          tipoFormulario: this.destinatarioSeleccionado ? this.tipoFormulario : null,
          temaMotivo: this.destinatarioSeleccionado ? this.temaMotivo : null,
          idAsistenteAccion: this.assistanceId,
          idDestinatario:
          this.tipoVinculacion === '0'
              ? this.destinatarioSeleccionado?.destinatario?.id ?? null
              : null,

          codigoAsistenteAccion:
            this.tipoVinculacion === '1'
              ? this.codigoAsistenteAccion
              : null,
          requiereAutenticacion: this.requiereAutenticacion,
          visible: this.visible,
          encoladoMaximo: this.encoladoMaximo,
          guardarHistorico: this.guardarHistorico,
          requiereEncuesta: this.requiereEncuesta,
          codigoEncuesta: this.codigoEncuesta,
          listaValidaciones: this.listaValidaciones
          // old
          /*
          idMenu: this.node.menuId,
          tipoNodo: this.nodeType,
          idPadre: this.node.parentId,
          pregunta: this.name,
          respuesta: this.answer,
          idAsistencia: this.assistanceId,
          orden: this.position,
          userName: this.authService.getUser().username,
          codigoTemaDestinatario: areaCode && areaCode != '-1' ? areaCode : '',
          esFormulario: this.esFormulario
          */
        } as Partial<Nodo>

        let count = 0;
        for (let node of this.siblingsArrTmp) {
          count++;
          if (count == this.position) {
            count++;
          }
          const nodeUpdate: Partial<Nodo> = {
            idNodo: node.id,
            nombre: node.name,
            respuesta: node.answer,
            idContenido: node.idContenido,
            url: node.url,
            orden: count,
            usuarioActualizacion: this.authService.getUser().username,
            // idDestinatario: node.idDestinantario,
            // tipoFormulario: node.tipoFormulario
            /*
            pregunta: node.name,
            respuesta: node.answer,
            idAsistencia: node.assistanceId,
            orden: count,
            userName: this.authService.getUser().username,
            codigoTemaDestinatario: node.areaCode,
            esFormulario: node.esFormulario
            */
          }
          nodosActualizar.push(nodeUpdate);
        }

        resArray.push(await this.configService.addUpdateNodes(this.node.menuId, this.authService.getUser().username, nodoCrearActualizar, nodosActualizar).toPromise().catch((err) => {
          this.loading = false;
          alert(err);
          this.resetComponent()
        }));

        let noErr = resArray.reduce((previous, current) => {
          return previous && (current.statusCode == 200 || current.statusCode == 0);
        }, true)

        if (noErr) {
          this.node.menuId = this.idMenu;
          this.node.name = this.name;
          this.node.answer = this.answer;
          this.node.idContenido = this.idContenido;
          this.node.url = this.url;
          this.node.assistanceId = this.assistanceId;
          this.node.codigoAsistenteAccion = this.codigoAsistenteAccion;
          this.nodeEmitter.emit(this.node.parentId);
          this.reloadConfig.emit(this.node.idAsistente);
          this.resetComponent();
          this.loading = false;
        }
        else {
          this.loading = false;
          alert("Ocurrió un error, intente nuevamente más tade");
          this.resetComponent()
        }
        this.errorValidacionCreacionNodo = false;
      } else {
        this.loading = false;
        this.errorValidacionCreacionNodo = true;
      }
    }
  }

  /**
   * Validador para la creación de un nodo
   */
  isCreateNodeDataValid() {
    if (this.nodeType === NodeType.Response && this.name  && (this.answer || this.idContenido) && this.position) {
      if(this.tipoVinculacion=='0' && !(this.temaMotivo && this.tipoFormulario)) {
        return false;
      }
      return true;
    } else if (this.nodeType === NodeType.Question  && this.name && this.position) {
      if(this.tipoVinculacion=='0' && !(this.temaMotivo && this.tipoFormulario)) {
        return false;
      }
      return true;
    } else if ((this.nodeType === NodeType.Action) && this.name && this.codigoAsistenteAccion && this.position && (!this.esFormulario || (this.esFormulario && this.destinatarioSeleccionado))) {
      return true;
    } else if (this.nodeType === NodeType.Tramite  && this.name && this.idContenido && this.position) {
      if(this.tipoVinculacion=='0' && !(this.temaMotivo && this.tipoFormulario)) {
        return false;
      }
      return true;
    } else if ((this.nodeType === NodeType.Enlace) && this.name && this.url && this.position) {
      return true;
    }
    // agrego validaciones para chat
    else if ((this.nodeType === NodeType.Chat && this.name && this.temaMotivo && this.destinatarioSeleccionado && this.position)) {
      return true
    }
    // agrego validaciones para chat
    else if ((this.nodeType === NodeType.Form && this.name && this.temaMotivo && this.destinatarioSeleccionado && this.position && this.tipoFormulario)) {
      return true
    }
    else {
      return false;
    }
  }


  async deleteNode() {
    this.loading = true;
    let nodosActualizar = [];
    if (this.node.type !== NodeType.FAQ) {
      let resArray = [];
      //mantengo el orden
      let count = 0;
      for (let node of this.siblingsArrTmp) {
        if (node.id != this.node.id) {
          count++;
          const nodeUpdate: Partial<Nodo> = {
            idNodo: node.id,
            nombre: node.name,
            respuesta: this.answer,
            idContenido: this.idContenido,
            url: this.url,
            orden: count,
            usuarioActualizacion: this.authService.getUser().username,
            idDestinatario: node.idDestinatario
          }
          nodosActualizar.push(nodeUpdate);
        }
      }

      resArray.push(await this.configService.deleteUpdateNodes(this.node.idAsistente, this.node.id, this.authService.getUser().username, nodosActualizar).toPromise().catch((err) => {
       // debugger
        this.loading = false;
        alert(err);
        this.resetComponent()
      }));

      let noErr = resArray.reduce((previous, current) => {
        //debugger
        return previous && (current.statusCode == 200 || current.statusCode == 0 ? true : false);
      }, true)

      if (noErr) {
        this.node.name = this.name;
        this.node.answer = this.answer;
        this.node.idContenido = this.idContenido,
          this.node.url = this.url,
          this.node.assistanceId = this.assistanceId;
        this.node.codigoAsistenteAccion = this.codigoAsistenteAccion;
        this.nodeEmitter.emit(this.node.parentId);
        // this.nodeEmitter.emit(this.node.id);
        this.reloadConfig.emit(this.node.idAsistente)
        this.resetComponent()
        this.loading = false;
      }
      else {
        this.loading = false;
        alert("Ocurrió un error, intente nuevamente más tade");
        this.resetComponent()
      }
    }
    else {
      this.configService.deleteFaqNode(this.node.id, this.authService.getUser().username).subscribe((res: any) => {
        if (res.statusCode == 200 || res.statusCode == 0) {
          //console.log("this.parentId",this.parentId,"this.parent",this.parent);
          this.nodeEmitter.emit(this.parent ? this.parent.id: this.parentId);
          this.reloadConfig.emit(this.idMenu)
          this.resetComponent();
          this.loading = false;
        }
        else {
          this.loading = false;
          alert(res.statusMessage);
          this.resetComponent();
        }

      },
        (error) => {
          this.loading = false;
          alert(error);
          this.resetComponent();
        })
    }
  }


  toggleSelection(event, node) {
    let selected = event.checked;
    if (selected) {
      let faqNode = new NodoArbolMenu(node.id, node.menuId, node.consulta, undefined, NodeType.FAQ, this.node.parentId, undefined, undefined, undefined, undefined, undefined, undefined, 1, undefined, undefined, this.authService.getUser().username);
      this.selectedFAQNodes.set(faqNode.id, faqNode);
    }
    else {
      this.selectedFAQNodes.delete(node.id);
    }

  }

  emptyValues() {
    this.name = undefined;
    this.answer = undefined;
    this.idContenido = undefined;
    this.url = undefined;
    this.assistanceId = undefined;
    this.codigoAsistenteAccion = undefined;
    this.temaMotivo = undefined;
    this.destinatarioSeleccionado = undefined;
    //this.tipoFormulario=undefined;
    if(this.nodeType === 'ACCION') {
      this.tipoVinculacion = '1';//Esto es siempre asi
    } else {
      this.tipoVinculacion = '0';
    }
    
    //console.log(this.nodeType)
    //console.log(this.node.type)
    this.obtenerDestinatariosPosibles();
  }

  // jsEscape(str){
  //   return String(str).replace(/[^\w. ]/gi, function(c){
  //      return '\\u'+('0000'+c.charCodeAt(0).toString(16)).slice(-4);
  //   });

  // }


  updateVisiblePath() {
    if(this.possibleFaqs) {
      for (let faq of this.possibleFaqs) {

        if (faq.path.length > this.maxPathLength) {
          faq.path = faq.path.replaceAll("->", " -> ");
          let split = faq.path.split(">");
          let i = split.length - 1;
          let aux = "";
          while (i > 0) {
            if (aux.length + split[i].length > this.maxPathLength) {
              break;
            }
            if (i !== split.length - 1) {
              aux = split[i] + ">" + aux;
            }
            else { aux = split[i] }
            i--;
          }
          aux = aux === "" ? split[i] : aux;
          faq.path = "... " + aux;
        }
        else {
          faq.path = faq.path.replaceAll("->", " -> ");
        }

      }
    }

  }

  editorOptions = {
    modules: {
      clipboard: {
        matchVisual: false
      }
    }
  };

  obtenerDestinatariosPosibles() {
    if (!this.destinatariosMenu) return;

    this.destinatariosMenuDisponibles = this.destinatariosMenu.filter(x => {
      if ((this.nodeType === NodeType.Chat || this.nodeType === NodeType.Form) && x.id == null) {
        return false;
      }
      if (this.nodeType === NodeType.Chat) {
        return x.destinatario.targetType?.toUpperCase() === DestinatarioTipo.Chat;
      }
      if (this.nodeType === NodeType.Form) {
        return x.destinatario.targetType?.toUpperCase() === DestinatarioTipo.Email;
      }

      return true;
    });
    this.sinDestinatarios = this.destinatariosMenuDisponibles.length === 0;
  }



}
